import React from 'react';
import { Box, Typography } from '@mui/material';
import Data from '../../Data/PersonalInfo.json';

//  @desc - `FULLSTACK DEVELOPER`
const Designation = () => {
  return (
    <>
      {Data.designation.map(({ title1, title2 }) => (
        <Box key={`${title1}-${title2}`}>
          <Box>
            <Typography variant='title'>{title1}</Typography>
          </Box>
          <Box>
            <Typography
              variant='title'
              sx={{
                lineHeight: '0.4',
              }}
            >
              {title2}
            </Typography>
          </Box>
        </Box>
      ))}
    </>
  );
};

export default Designation;
